import React, { Component } from 'react';
import { Card } from 'antd';
import moment from 'moment';
import { BackBtn } from '@comm/BackBtn';
import Line from '@comm/charts/Line2/Index';
import { queryAnalysisProfit, queryAnalysisProfitDetail } from '@api/finance/budget';
import YearPicker from '@comm/YearPicker';
import TableDetail from './TableDetail';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recordData: {
        list: [],
        pagination: {},
      },
      date: [],
      expenditure: [],
      income: [],
      aim: [],
      profit: [],
    };
  }

  componentWillMount() {
    this.year =
      this.props.location.query.year || moment.unix(new Date().getTime() / 1000).format('YYYY');
  }

  componentDidMount() {
    this.getProfitChartData();
    this.getProfitDetail();
  }

  findTypeName = record => {
    let typeName = '';
    const { incomeType, expendType } = this.props;
    const type = record.target === 0 ? expendType : incomeType;
    type.forEach(item => {
      if (record.type === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  getProfitChartData = () => {
    const date = [];
    const expenditure = [];
    const income = [];
    const profit = [];
    const aim = [];
    queryAnalysisProfit({
      groupUuids: this.props.params.uuid,
      year: this.year,
    }).then(res => {
      if (res.statusCode === 200) {
        res.data.detail.map(item => {
          date.push(item.date || 0);
          expenditure.push(item.expenditure || 0);
          income.push(item.income || 0);
          profit.push(item.profit || 0);
          aim.push(item.aim || 0);
          return item;
        });
        this.setState({
          date,
          expenditure,
          income,
          aim,
          profit,
        });
      }
    });
  };

  getProfitDetail = () => {
    const pageSize = 15;
    queryAnalysisProfitDetail({
      groupUuids: this.props.params.uuid,
      target: 1,
      limit: pageSize,
      start: this.current || 1,
      year: this.year,
    }).then(res => {
      // res.data.map (item => (item.typeName = this.findTypeName (item)));
      this.setState({
        recordData: {
          list: res.data,
          pagination: {
            total: res.totalSize,
            pageSize,
            current: this.current,
          },
        },
      });
    });
  };

  handleTableChange = pagination => {
    this.current = pagination.current;
    this.getProfitDetail();
  };

  handleYearChange = year => {
    this.year = year;
    this.getProfitDetail();
    this.getProfitChartData();
  };

  render() {
    const { recordData, date, expenditure, income, profit, aim } = this.state;
    const line2Props = {
      title: '利润追踪',
      legend: ['支出', '收入', '利润', '月目标'],
      xAxisData: date,
      series: [
        {
          name: '支出',
          type: 'line',
          data: expenditure,
        },
        {
          name: '收入',
          type: 'line',
          data: income,
        },
        {
          name: '利润',
          type: 'line',
          data: profit,
        },
        {
          name: '月目标',
          type: 'line',
          data: aim,
        },
      ],
    };
    return (
      <div className="analyze">
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
          <YearPicker
            style={{ width: '150px' }}
            onChange={this.handleYearChange}
            defaultValue={this.year}
          />
        </div>
        <Card title="利润追踪">
          <Line {...line2Props} />
        </Card>
        <TableDetail data={recordData} handleChange={this.handleTableChange} />
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/finance/budget/balance/profit/Index.js